import React, { useContext } from "react";

import { DealerContextProvider } from "../../contexts/DealerContext.jsx";
import PDPDealerAccordion from "./PDPDealerAccordion.jsx";

const PDPDealer = ({radius, filters, apiKey}) => {
    return (
        <DealerContextProvider apiKey={apiKey} defaultFilters={filters}>
            <PDPDealerAccordion radius={radius}/>
        </DealerContextProvider>
    );
}

export default PDPDealer;